<template>
  <main class="contenedor">
    <LoadingSpinner v-if="loadingOptionsList || loading" />
    <div class="card mt-3 mb-5" v-if="!loadingOptionsList && !loading">
      <div class="px-4 pb-2 pt-4">
        <div>
          <AgencyContractDetail :model="model" />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { clientsService } from "@/_services";
import TargetsView from "@/components/Agencies/TargetsView.vue";
import AgencyContractDetail from "@/components/Agencies/AgencyContractDetail.vue";

export default {
  props: {},
  data() {
    return {
      loading: false,
      model: {},
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },
  components: {
    LoadingSpinner,
    TargetsView,
    AgencyContractDetail
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      loadingOptionsList: (state) => !state.optionsList.completeLoading,
      hierarchyoptions: (state) => state.optionsList.all["regions"].data,
      hierarchyoptionsSearch: (state) =>
        state.optionsList.all["categories_search_words"].data,
      hierarchyoptionsSearchFunction: (state) =>
        state.optionsList.all["categories_search_function"].data,
      hierarchyoptionsSearchLevel: (state) =>
        state.optionsList.all["categories_search_level"].data,
      hierarchyoptionsGoogle: (state) =>
        state.optionsList.all["categories_google"].data,
      companySizeOptions: (state) => state.optionsList.all["param_5"].data,
      hierarchyoptionsGoogleAll: (state) =>
        state.optionsList.all["categories_google_all"].data,
      hierarchyoptionsCountry: (state) =>
        state.optionsList.all["countries"].data,
    }),

    appt_start_date() {
      return this.model.client.appt_start_date.substring(0, 10);
    },
  },
  created() {
    this.getAllOptionsList();
    this.getAgency();
  },
  methods: {
    ...mapActions("optionsList", {
      getAllOptionsList: "getAll",
    }),
    getAgency() {
      this.loading = true;
      clientsService.getAgency(0).then((response) => {
        this.model = response;

        if (this.model.targets !== undefined && this.model.targets !== null) {
          this.model.targets.forEach((target) => {
            // convert empty array into object
            if (Array.isArray(target.data.employees)) {
              target.data.employees = {};
            }
            if (
              target.data.categories_jobs === undefined ||
              Array.isArray(target.data.categories_jobs)
            ) {
              target.data.categories_jobs = {};
            }
          });
        }
        this.loading = false;
      });
    },
  },
  watch: {},
};
</script>